import { render } from "./InfoArtistModal.vue?vue&type=template&id=8ee3f3da&scoped=true"
import script from "./InfoArtistModal.vue?vue&type=script&lang=js"
export * from "./InfoArtistModal.vue?vue&type=script&lang=js"

import "./InfoArtistModal.vue?vue&type=style&index=0&id=8ee3f3da&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ee3f3da"]])

export default __exports__